const toTitleCase = (value: string | null | undefined) => {
  const val = value ? value.replaceAll('_', ' ') : '';
  return val.charAt(0).toUpperCase() + val.slice(1);
};

export default toTitleCase;
